import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import FormSelect from "core/gd-form/form-element/select-new/select-new";

export default function CustomFieldFormat(props) {

    const formatTypeOptions = [
        { label: "Number",      value: 'number' },
        { label: "Currency",    value: 'currency' },
        { label: "Percentage",  value: 'percentage' },
    ]

    return (
        <FormRow label="Format">
            <FormSelect form={props.form}
                        name="formatType"
                        options={formatTypeOptions}/>
            <FormError form={props.form} name="formatType" />
        </FormRow>
    );
}

CustomFieldFormat.propTypes = {
    form: PropTypes.object
}